import { UploadOutlined } from "@ant-design/icons";
import { Button, message, Upload } from "antd";
import { UploadChangeParam } from "antd/lib/upload";
import { UploadFile } from "antd/lib/upload/interface";
import React, { useEffect, useState } from "react";
import { getToken } from "utils/auth";
// import "./style/fileUpload.scss";

export const SingleFileUpload = ({
  onUploadOk,
  onDelete,
  onBefore,
  fileList,
  fileTypes,
  fileTypeText = "PDF",
  placeholder,
  acceptType,
  readOnly = false,
  uploadUrl = import.meta.env.VITE_API_URL + "/v1/admin/issue/upload",
  multiple = true,
  allowDownload = true,
}: {
  fileList: UploadFile[];
  fileTypeText?: string;
  fileTypes?: string[];
  placeholder?: string;
  uploadUrl?: string;
  acceptType?: string;
  readOnly?: boolean;
  onDelete: (uid: string) => void;
  onUploadOk: (file: any) => void;
  onBefore?: () => Promise<boolean>;
  multiple?: boolean;
  allowDownload?: boolean;
}) => {
  const [loading, setLoading] = useState(false);
  const [fileListOrigin, setFileListOrigin] = useState<UploadFile[]>();

  useEffect(() => {
    setFileListOrigin(() => fileList.map((e) => ({ ...e })));
  }, [fileList]);

  const checkFileType = async (file: File) => {
    const ext = file.name.split(".").pop()?.toLowerCase();

    const allowExtensions = ["doc", "docx", "xls", "xlsx", "json"];

    if (!ext || !allowExtensions.includes(ext)) {
      message.error("Chỉ chấp nhận các định dạng: .doc, .docx, .xls, .xlsx, .json");
      return Upload.LIST_IGNORE;
    }

    if (onBefore) {
      const isValid = await onBefore();
      if (!isValid) {
        return Upload.LIST_IGNORE;
      }
    }

    return true;
  };

  const handleChange = (info: UploadChangeParam) => {
    if (info.file.status === "uploading") {
      setLoading(true);
      setFileListOrigin([...info.fileList]);
      return;
    }

    if (info.file.status === "done") {
      // info.file.name luôn là tên gốc của file người dùng chọn
      const originalName = info.file.name;
      setFileListOrigin(
        info.fileList.map((file) => (file.uid === info.file.uid ? { ...file, name: originalName } : file)),
      );
      onUploadOk({ ...info.file.response?.data, originalname: originalName });
      message.success("Upload thành công");
      setLoading(false);
      return;
    }

    if (info.file.status === "removed") {
      setFileListOrigin([...info.fileList]);
      onDelete(info.file.uid);
      return;
    }

    if (info.file.status === "error") {
      setLoading(false);
      setFileListOrigin([...info.fileList]);
      message.error("Upload thất bại");
    }
  };

  return (
    <>
      <Upload
        beforeUpload={checkFileType}
        action={uploadUrl}
        headers={{ token: getToken() || "" }}
        accept={acceptType}
        onChange={handleChange}
        fileList={fileListOrigin}
        onPreview={(file) => allowDownload && window.open(file.url || file.uid, "_blank")}
        maxCount={1}
        disabled={readOnly}
        multiple={multiple}
      >
        <Button icon={<UploadOutlined />} loading={loading}>
          {placeholder ? placeholder : "Chọn file"}
        </Button>
      </Upload>
    </>
  );
};
